import { isNotDefined, SYSTEM_UNASSIGNED_USER_ID } from '@terros/common'
import { isInWindows, type TimeWindow } from './ownershipWindows'
import { type AccountActivityItem } from './accountActivity'

type WindowedItemProps = {
  item: AccountActivityItem
  visibleWindows: TimeWindow[] | undefined
}

// The owner change that closes a window stays too: it's when the account was taken away
export const isVisible = ({ item, visibleWindows }: WindowedItemProps): boolean => {
  if (isNotDefined(visibleWindows)) return true
  return isInWindows({ timestamp: item.timestamp, windows: visibleWindows }) || isWindowEnd({ item, visibleWindows })
}

const isWindowEnd = ({ item, visibleWindows = [] }: WindowedItemProps): boolean =>
  item.type === 'owner' && visibleWindows.some(({ end }) => end === item.timestamp)

/** Closing a window reads "Unassigned from …": who got the account next is part of the hidden history */
export const toUnassignmentAtWindowEnd = ({ item, visibleWindows }: WindowedItemProps): AccountActivityItem => {
  if (item.type !== 'owner' || !isWindowEnd({ item, visibleWindows })) return item
  return { ...item, userId: SYSTEM_UNASSIGNED_USER_ID, actor: undefined, areaRunAt: undefined }
}

/**
 * The assignment that opens each visible window reads as a plain "Assigned to …": who had the account before,
 * and who moved it, are part of the history being hidden.
 */
export const hidePreviousAssignment = ({ item, visibleWindows }: WindowedItemProps): AccountActivityItem => {
  if (isNotDefined(visibleWindows) || !visibleWindows.some(({ start }) => start === item.timestamp)) return item
  if (item.type === 'owner' || item.type === 'closer') return { ...item, previousUserId: undefined, actor: undefined }
  if (item.type === 'team') return { ...item, previousTeamId: undefined, actor: undefined }
  return item
}
